<template>
    <div class="grid-wrapper">
        <b-container fluid>
            <section class="grid-filters">
                <b-row>
                    <b-col cols="12" md="9">
                        <h3>
                            <font-awesome-icon
                                    :icon="['fas', 'users']"
                                    size="sm"
                            ></font-awesome-icon>
                            {{ gridTitle }}
                        </h3>
                    </b-col>
                    <b-col cols="12" md="3" class="text-md-right">
                        <b-dropdown v-if="userTeams.length > 1">
                            <template slot="button-content">
                                <font-awesome-icon
                                        :icon="['fas', 'users']"
                                        size="sm"
                                ></font-awesome-icon>
                                My Teams
                            </template>
                            <b-dropdown-item v-for="item in userTeams"
                                 :value="item.teamId"
                                 @click="selectUserTeam(item)"
                            >
                                {{item.team}}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </b-row>
            </section>
            <ag-grid-vue
                    :cacheQuickFilter="true"

                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :columnTypes="columnTypes"
                    :floatingFilter="false"

                    :gridOptions="gridOptions"

                    @gridReady="onGridReady"
                    :headerHeight="rowHeight"
                    :rowData="rowData"
                    :rowHeight="rowHeight"

                    style="width: 100%;"
                    :suppressContextMenu="true"
                    :suppressExcelExport="true"
                    domLayout="autoHeight"

                    class="ag-theme-balham"
            ></ag-grid-vue>
        </b-container>
    </div>
</template>

<script>
import GridMixin from '@/components/Grid/GridMixin';
import { teamUserGridColumnTypes, gridColumns, gridDefaultColDef } from '@/services/Team/TeamUserGrid';
import Team from '@/services/Team/Team';
import ActionStatus from '@/services/Action/ActionStatus';

export default {
  name: 'TeamGrid',
  mixins: [GridMixin],
  props: {
    userTeams: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
      columnTypes: teamUserGridColumnTypes,
      gridTitle: 'Team Users',
      selectedTeam: null,
    };
  },
  created() {
    [this.selectedTeam] = this.userTeams;
  },
  methods: {
    postGridReady() {
      const user = this.$store.getters.authUser;
      const { teams } = user;

      if (this.userTeams.length) {
        this.refresh();
      }

      this.handleResize();
    },
    async refresh() {
      this.refreshing = true;

      try {
        this.gridTitle = this.selectedTeam.team + ' Users';

        const { data } = await Team.users(this.selectedTeam.teamId, {actions: 1, active: 1});

        const formattedData = this.formatRowData(data.data);

        this.rowData = formattedData;

        this.refreshing = false;

      } catch (e) {

      }
    },
    formatRowData(data) {
      return data.map((row) => {
        const { firstName, lastName, lastLoginDate, actions } = row;
        const name = `${firstName} ${lastName}`;

        const currentDate = new Date();

        const assigned = actions.filter(action => action.status === ActionStatus.ASSIGNED()).length;
        const completed = actions.filter(action => action.status === ActionStatus.APPROVED()).length;
        const overdue = actions.filter(action => action.dueDate && (new Date(action.dueDate) < currentDate)
            && action.status !== ActionStatus.APPROVED()).length;

        return {
          name,
          lastLoginDate,
          assigned,
          completed,
          overdue,
        };
      });
    },
    selectUserTeam(team) {
      this.selectedTeam = team;
      this.refresh();
      this.gridApi.sizeColumnsToFit();
    },
    handleResize() {
      const deviceWidth = window.innerWidth;

      this.columnApi.setColumnVisible('assigned', false);
      this.columnApi.setColumnVisible('completed', false);
      this.columnApi.setColumnVisible('overdue', false);

      if (deviceWidth >= 768) {
        this.columnApi.setColumnVisible('assigned', true);
        this.columnApi.setColumnVisible('completed', true);
      }

      if (deviceWidth >= 992) {
        this.columnApi.setColumnVisible('overdue', true);
      }

      this.gridApi.sizeColumnsToFit();
    },
  },
};
</script>

<style scoped>
    .grid-wrapper {
        margin-top: 2em;
    }
    .grid-filters {
        margin-bottom: 1em;
    }
</style>
